import { Controller } from '@hotwired/stimulus'
import * as Turbo from '@hotwired/turbo'

export default class extends Controller<HTMLLinkElement> {
  static targets = ['button']

  static values = {
    open: Boolean,
    visitUrl: String
  }

  declare readonly buttonTarget: HTMLElement
  declare readonly hasButtonTarget: boolean
  declare readonly hasVisitUrlValue: boolean
  declare openValue: boolean
  declare visitUrlValue: string

  initialize (): void {
    if (this.openValue) {
      setTimeout(() => {
        const button = this.hasButtonTarget ? this.buttonTarget : this.element
        button.click()
      }, 100)
    }
  }

  navigate ({ currentTarget }: { currentTarget: HTMLLinkElement }): void {
    this.navigateTo({ params: { url: currentTarget.href } })
  }

  formNavigate (event: Event & { detail: { fetchResponse: { response: { url: string } } } }): void {
    if (event.target !== this.element) return

    this.navigateTo({ params: { url: event.detail.fetchResponse.response.url } })
  }

  navigateTo ({ params: { url } }: { params: { url: string } }): void {
    Turbo.navigator.history.replace(new URL(url, location.origin))
  }

  visitToUrl (): void {
    if (this.hasVisitUrlValue) Turbo.visit(this.visitUrlValue)
  }

  navigateToCurrentAddParam ({ params: { name, value } }: { params: { name: string, value: string } }): void {
    const url = new URL(location.href)

    url.searchParams.set(name, value)

    Turbo.navigator.history.replace(url)
  }

  navigateToCurrentDelParam ({ params: { name } }: { params: { name: string } }): void {
    const url = new URL(location.href)

    url.searchParams.delete(name)

    Turbo.navigator.history.replace(url)
  }
}
